export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/9efedd6f8d84b8cf11b1862201b47d04.svg";